import { gql } from '@apollo/client';

export const GET_CSV = gql`
  query GetProductsCSV($input: ProductsInput) {
  getProductsCsv(input: $input) {
    csv
  }
}
`;
